import React, { useState } from "react";
import { useTranslation } from "react-i18next";

const WorkspaceCard = ({
  title,
  imgSrc,
  requiresPeople,
  placeholder,
  tooltipText,
  people,
  handleInputChange,
  handleAdd,
  setReception,
}) => {
  const [currentTooltip, setCurrentTooltip] = useState("");
  const { t } = useTranslation();

  return (
    <div className="mr-2 w-full md:flex-1 flex-1 mb-6">
      <figure className="text-center relative max-w-max mx-auto">
        <figcaption className="mb-2">{t(title)}</figcaption>
        <img src={imgSrc} alt={t(title)} />
        <span
          className="absolute top-10 right-2 bg-red-600 text-white rounded-full w-6 h-6 flex items-center justify-center cursor-pointer"
          onMouseEnter={() => setCurrentTooltip(title)}
          onMouseLeave={() => setCurrentTooltip("")}
        >
          ?
          {currentTooltip === title && (
            <div className="absolute top-full right-0 text-xs bg-black text-white p-2 rounded z-10 w-48" >
              {t(tooltipText)}
            </div>
          )}
        </span>
      </figure>
      <div className="mt-3 max-w-fit mx-auto">
        {requiresPeople ? (
          <div>
            <input
              type="text"
              placeholder={placeholder}
              value={people[title]}
              onChange={(e) => handleInputChange(title, e.target.value)}
              maxLength={5}
              className="rounded-lg w-9 h-9 border border-cyan-900 text-center text-cyan-900"
            />
            <span className="ml-2">people</span>
          </div>
        ) : (
          <div className="border max-w-[122px] mx-auto flex items-center rounded-lg p-2 border-border-green-1">
            <button
              onClick={() => {
                // Math.max(0, state[action.item] - 1);
                handleInputChange(
                  title,
                  Math.max(0, Number(people[title]) - 1)
                );
              }}
            >
              <i class="fa-solid fa-minus text-sm"></i>
            </button>

            <input
              type="number"
              placeholder={placeholder}
              value={people[title]}
              onChange={(e) => handleInputChange(title, e.target.value)}
              className="border-none w-full text-center text-gray-light focus-visible:outline-none"
            />

            <button
              onClick={() => {
                if (!isNaN(Number(people[title]))) {
                  handleInputChange(title, Number(people[title]) + 1);
                } else {
                  handleInputChange(title, 1);
                }
              }}
            >
              <i class="fa-solid fa-plus text-sm"></i>
            </button>
          </div>
        )}
        <button
          onClick={() => handleAdd(title)}
          className="block w-21 mx-auto mt-3 px-3 py-1 bg-red-600 rounded-3xl text-white cursor-pointer hover:bg-white border-red-600 border hover:text-red-600 transition-colors duration-300 ease-in-out"
        >
          {t("add")} <i className="fas fa-plus text-sm"></i>
        </button>
      </div>
    </div>
  );
};

export default WorkspaceCard;
